import React from 'react';
import Gasto from './Gasto';

const Listado = ({gastos}) => (
    <div className='gastos-realizados'>
        <h1 className='text-center mt-4'>Gastos Realizados</h1>
        {gastos.map(gasto => (
            <Gasto 
                key={gasto.id}
                gasto={gasto}
            />
        ))}
    </div>
)
 
export default Listado;